<template>
  <!--<card :modifier-classes="['card--v']" :target="link.url">
    <template v-slot:card-image>
      <prismic-image :field="image"></prismic-image>
    </template>
    <template v-slot:card-content>
      <h3>{{ title }}</h3>
      <p class="lead-text">{{ text }}</p>
    </template>
    <template v-if="link.url" v-slot:card-action>
      <prismic-link class="btn btn-primary btn--large" :field="link">{{ KriensTourismus.languageKeys['to-website'] }}</prismic-link>
    </template>
  </card>-->
  <modal-card :image="image"
              :title="title"
              :text="text"
              :meta="meta"
              :link="link"
  ></modal-card>
</template>

<script>
import ModalCard from '../../elements/ModalCard.vue'

export default {
  name: "SightItem",
  components: {
    ModalCard
  },
  props: ["title", "image", "text", "meta", "link"]
};
</script>
